import { useCallback } from 'react'
import { Modal, ModalBody, Text, Button, Flex, InjectedModalProps } from '@pancakeswap/uikit'
import { useTranslation } from '@pancakeswap/localization'
import isEmpty from 'lodash/isEmpty'
import styled, { css } from 'styled-components'
import groupBy from 'lodash/groupBy'
import { useAllSortedRecentTransactions } from 'state/transactions/hooks'
import { TransactionDetails } from 'state/transactions/reducer'
import { useAppDispatch } from 'state'
import { clearAllTransactions } from 'state/transactions/actions'
import { chains } from 'utils/wagmi'
import { useAccount } from 'wagmi'
import { AutoRow } from '../../Layout/Row'
import Transaction from './Transaction'
import ConnectWalletButton from '../../ConnectWalletButton'

const StyledModal = styled(Modal)<{ $hasAccount: boolean }>`
  > div:last-child {
    padding: 16px;
    height: ${({ $hasAccount }) => ($hasAccount ? 'unset' : '133px')};
    ${({ $hasAccount }) =>
      !$hasAccount &&
      css`
        justify-content: center !important;
        padding: 16px !important;
      `}
  }
  &:nth-child(2) {
    padding: 0 !important;
  }

  @media screen and (max-width: 768px) {
    width: 100% !important;
  }
`

const StyledConnectButton = styled(ConnectWalletButton)`
  border-radius: 12px;
`

const ClearButton = styled(Text)`
  transition: 400ms;
  cursor: pointer;
  padding: 4px 16px;
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  color: #2e81ff;
  background-color: #4f90ff1a;
  border-radius: 999px;

  &:hover {
    opacity: 0.65;
  }
`

function renderTransactions(transactions: TransactionDetails[], chainId: number, isSwap?: boolean) {
  return (
    <Flex flexDirection="column">
      {transactions.map((tx) => {
        return <Transaction key={tx.hash + tx.addedTime} tx={tx} chainId={chainId} isSwap={isSwap} />
      })}
    </Flex>
  )
}

const TransactionsModal: React.FC<React.PropsWithChildren<InjectedModalProps>> = ({ onDismiss }) => {
  const { address: account } = useAccount()
  const dispatch = useAppDispatch()
  const sortedRecentTransactions = useAllSortedRecentTransactions()

  const { t } = useTranslation()

  const hasTransactions = !isEmpty(sortedRecentTransactions)

  const clearAllTransactionsCallback = useCallback(() => {
    dispatch(clearAllTransactions())
  }, [dispatch])

  return (
    <StyledModal
      width={424}
      title={t('Recent Transactions')}
      headerBackground="gradientCardHeader"
      onDismiss={onDismiss}
      $hasAccount={!!account}
    >
      {account ? (
        <ModalBody>
          <ScrollWrap>
            {hasTransactions ? (
              <>
                <AutoRow mb="1rem" style={{ justifyContent: 'flex-end' }}>
                  {/* <Text>{t('Recent Transactions')}</Text> */}
                  <ClearButton onClick={clearAllTransactionsCallback}>{t('Clear all')}</ClearButton>
                </AutoRow>
                {Object.entries(sortedRecentTransactions).map(([chainId, transactions]) => {
                  const chainIdNumber = Number(chainId)
                  const groupedTransactions = groupBy(Object.values(transactions), (trxDetails) =>
                    Boolean(trxDetails.receipt),
                  )

                  const confirmed = groupedTransactions.true ?? []
                  const pending = groupedTransactions.false ?? []

                  return (
                    <div key={`transactions#${chainIdNumber}`}>
                      {/* <Text fontSize="12px" color="textSubtle" mb="4px">
                      {chains.find((c) => c.id === chainIdNumber)?.name ?? 'Unknown network'}
                    </Text> */}
                      {renderTransactions(pending, chainIdNumber, true)}
                      {renderTransactions(confirmed, chainIdNumber, true)}
                    </div>
                  )
                })}
              </>
            ) : (
              <Text
                style={{
                  marginTop: 20,
                  textAlign: 'center',
                  color: '#FFFFFF99',
                }}
              >
                {t('No recent transactions')}
              </Text>
            )}
          </ScrollWrap>
        </ModalBody>
      ) : (
        <StyledConnectButton />
      )}
    </StyledModal>
  )
}
const ScrollWrap = styled.div`
  height: 450px;
  overflow-y: auto;
  @media screen and (max-width: 700px) {
    height: unset;
  }
`
export default TransactionsModal
